module.exports = __webpack_public_path__ + "static/img/message-bg.6b597a82.webp";